import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterComponent } from './toaster.component';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';

@NgModule({
  declarations: [
    ToasterComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SvgIconComponent,
  ]
})
export class ToasterModule { }
